export default __webpack_public_path__ + "static/media/Goal_14.a8be2480.zip";